import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const outlineSetBlackoutDialogStyleId = 'service-plan-outline-set-blackout-dialog-theme';

/**
 * The reason-prompt token set plus what a two-month range picker needs: a bordered card around the
 * grids, and a summary line weighted heavier than the caption because it carries the answer.
 */
export const outlineSetBlackoutDialogBridgeStyles = {
  'service-plan-outline-set-blackout-dialog': {
    '--local-set-blackout-bg': tokens.color.background.primary,
    '--local-set-blackout-title': tokens.color.text.primary,
    '--local-set-blackout-body': tokens.color.text.secondary,
    '--local-set-blackout-label': tokens.color.text.secondary,
    '--local-set-blackout-summary': tokens.color.text.primary,
    '--local-set-blackout-date-weight': tokens.font.weight.medium,
    '--local-set-blackout-field-border': tokens.color.border.primary,
    '--local-set-blackout-field-bg': tokens.color.background.primary,
    '--local-set-blackout-gap': tokens.spacing.lg,
    '--local-set-blackout-head-gap': tokens.spacing.sm,
    '--local-set-blackout-field-gap': tokens.spacing.sm,
    '--local-set-blackout-pad': tokens.spacing.xl,
    '--local-set-blackout-calendar-pad': tokens.spacing.lg,
    '--local-set-blackout-field-pad-y': tokens.spacing.sm,
    '--local-set-blackout-field-pad-x': tokens.spacing.md,
    '--local-set-blackout-radius': tokens.radius.md,
    '--local-set-blackout-title-size': tokens.font.size.textLg,
    '--local-set-blackout-body-size': tokens.font.size.textSm,
    '--local-set-blackout-summary-size': tokens.font.size.textMdBase,
    '--local-set-blackout-title-weight': tokens.font.weight.semibold,
    '--local-set-blackout-line-title': tokens.lineHeight.textLg,
    '--local-set-blackout-line-body': tokens.lineHeight.textSm,
    '--local-set-blackout-line-summary': tokens.lineHeight.textMd,
    '--local-set-blackout-font': tokens.font.family.body,
    '--local-set-blackout-focus': tokens.focusRing.default,
  },
};
